import React from 'react';
import { PrinterIcon } from 'lucide-react';
const UTM = '?utm_source=meat_poultry_magazine';
export function ExhibitA() {
  const handlePrint = () => window.print();
  return <div className="min-h-screen w-full bg-gray-100 py-8 px-4 print:bg-white print:p-0" data-id="element-377" data-mp="ocabg1skdjcp">
      {/* Print control bar (hidden on print) */}
      <div className="max-w-3xl mx-auto mb-6 flex items-center justify-between print:hidden" data-id="element-378" data-mp="kbqilaf0x1wd">
        <a href="/" className="text-sm text-[#002f5f] hover:underline" data-id="element-379" data-mp="3srjx5jpso3as">
          &larr; Back to site
        </a>
        <button onClick={handlePrint} className="inline-flex items-center gap-2 px-4 py-2 bg-[#002f5f] text-white text-sm font-semibold rounded-md hover:bg-[#00274d] transition-colors" data-id="element-380" data-mp="3nsp29jejyoab">
          <PrinterIcon className="w-4 h-4" data-id="element-381" data-mp="leobhz1zcbs" />
          Print / Export PDF
        </button>
      </div>

      {/* Document */}
      <div className="max-w-3xl mx-auto bg-white shadow-sm print:shadow-none border border-gray-200 print:border-0 px-10 py-12 print:px-0" data-id="element-382" data-mp="39057p75gxp4h">
        {/* Header */}
        <header className="border-b-2 border-gray-900 pb-6 mb-8" data-id="element-383" data-mp="15ga9jem3iybi">
          <div className="flex items-baseline justify-between mb-4" data-id="element-384" data-mp="1af4scgk2cmvm">
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-gray-500" data-id="element-385" data-mp="1f6msj2e9ijfj">
              Exhibit A
            </span>
            <span className="text-xs text-gray-500" data-id="element-386" data-mp="1k5zfro91psin">Reference document</span>
          </div>
          <h1 className="text-3xl font-['Oswald'] font-bold uppercase tracking-wide text-gray-900 mb-2" data-id="element-387" data-mp="miqyy6jzp7mz">
            MeatMarket.ai Brand Placements
          </h1>
          <p className="text-sm text-gray-600 font-serif leading-relaxed" data-id="element-388" data-mp="rivftxot84dq">
            The following schedule catalogs each placement of the MeatMarket.ai
            name, mark, and outbound reference links integrated across the
            Meat+Poultry digital properties. All outbound links carry the UTM
            attribution parameter{' '}
            <code className="text-[11px] bg-gray-100 px-1 py-0.5 rounded" data-id="element-389" data-mp="2ctc2byf7i0by">
              {UTM}
            </code>
            .
          </p>
        </header>

        {/* Brand Marks & Lockups */}
        <section className="mb-10 break-inside-avoid" data-id="element-390" data-mp="7rzkkikwpdhc">
          <h2 className="text-xs font-bold uppercase tracking-[0.25em] text-gray-500 mb-4" data-id="element-391" data-mp="7vez9kao4ki8">
            Approved Brand Marks
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-392" data-mp="hqysu01rf73t">
            <figure className="border border-gray-200 rounded-lg p-5 flex flex-col" data-id="element-393" data-mp="3q71u9o2a3zjp">
              <div className="flex-1 flex items-center justify-center bg-white rounded-md py-6 px-4 mb-3 min-h-[96px]" data-id="element-394" data-mp="3q4nyfczryjb3">
                <img src="https://cdn.magicpatterns.com/uploads/oz5ZoYnYR5UjgdcDnLEJgq/Screenshot_2026-07-07_at_2.48.15_PM.png" alt="Powered by MeatMarket.ai text lockup" className="max-h-12 w-auto object-contain" data-id="element-395" data-mp="2tpqkbax4ixb" />
              </div>
              <figcaption className="text-xs text-gray-600" data-id="element-396" data-mp="32hzdeifgyaq9">
                <span className="font-semibold text-gray-900" data-id="element-397" data-mp="32fd4ofgudp6g">
                  "Powered by" attribution lockup.
                </span>{' '}
                Used inline within data ticker, market strips, and widget
                headers.
              </figcaption>
            </figure>
            <figure className="border border-gray-200 rounded-lg p-5 flex flex-col" data-id="element-398" data-mp="2ih66z01qqvvx">
              <div className="flex-1 flex items-center justify-center rounded-md py-6 px-4 mb-3 min-h-[96px]" data-id="element-399" data-mp="2nf7lr8s4w91l">
                <img src="https://cdn.magicpatterns.com/uploads/5SAysSTZFppjBWgsEp98Kc/Untitled_design_(1).png" alt="MeatMarket.AI primary logo mark with MM icon" className="max-h-12 w-auto object-contain" data-id="element-400" data-mp="3b4s7u0jl3mf3" />
              </div>
              <figcaption className="text-xs text-gray-600" data-id="element-401" data-mp="3632v8ggpr0ow">
                <span className="font-semibold text-gray-900" data-id="element-402" data-mp="1pqecq848khb8">
                  Primary logo mark.
                </span>{' '}
                The "MM" icon paired with the MeatMarket.AI wordmark, used for
                prominent brand placements.
              </figcaption>
            </figure>
          </div>
        </section>

        {/* Call to Action */}
        <section className="mb-10 break-inside-avoid" data-id="element-403" data-mp="264c2mvjnjzi8">
          <h2 className="text-xs font-bold uppercase tracking-[0.25em] text-gray-500 mb-4" data-id="element-404" data-mp="217vgg6w0jv7s">
            Call to Action
          </h2>
          <figure className="border border-gray-200 rounded-lg p-5 flex flex-col sm:flex-row sm:items-center gap-5" data-id="element-405" data-mp="1w5wf12ju38dh">
            <div className="flex items-center justify-center bg-white rounded-md py-6 px-4 min-h-[96px] sm:w-64 flex-shrink-0" data-id="element-406" data-mp="2owoeqa03yf5k">
              <img src="https://cdn.magicpatterns.com/uploads/amd5XME3Zf2Jo2P8LKafjR/Screenshot_2026-07-08_at_1.28.13_PM.png" alt="View More Data call-to-action button" className="max-h-12 w-auto object-contain" data-id="element-407" data-mp="2jwsbicz8irr2" />
            </div>
            <figcaption className="text-sm text-gray-600 leading-relaxed" data-id="element-408" data-mp="13j26n40ajzgd">
              <span className="font-semibold text-gray-900" data-id="element-409" data-mp="3f6oyn84c8aal">
                "View More Data" call-to-action.
              </span>{' '}
              This outbound button will be included in charts and tables on the
              pages within the Market IQ section of the site (/market-iq/beef,
              /market-iq/pork, and /market-iq/chicken), linking to the full
              MeatMarket.ai dataset.
            </figcaption>
          </figure>
        </section>

        {/* Footer */}
        <footer className="mt-10 pt-6 border-t border-gray-200 text-[11px] text-gray-400 flex items-center justify-between" data-id="element-410" data-mp="2rmorpivp2yi">
          <span data-id="element-411" data-mp="bpgiqtt67kii">Meat+Poultry &times; MeatMarket.ai — Exhibit A</span>
        </footer>
      </div>
    </div>;
}